module.exports = __webpack_public_path__ + "img/logo.23de2cb2.png";